import { render, staticRenderFns } from "./IP_ByCoderPrintable.vue?vue&type=template&id=53aaf39e&scoped=true&"
import script from "./IP_ByCoderPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_ByCoderPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_ByCoderPrintable.vue?vue&type=style&index=0&id=53aaf39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aaf39e",
  null
  
)

export default component.exports